import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LL_H_C, LL_V_L, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend/index';
import { OrderItem_EditorRenderer } from './editor/OrderItem_EditorRenderer.js';
import { Dialog_Confirmation, Header_WithOptionMenu } from '@app/styles';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { actionSubTypeLabelMap } from '@app/pathway-shared';
import { capitalizeFirstLetter } from '@nu-art/ts-common';
import './EditorWrapper_Order.scss';
import { TS_EditableItemStatus } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemStatus/TS_EditableItemStatus';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
const editKey = 'edit';
export class EditorWrapper_Order extends TS_EditableItemComponentProto {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        if (!state.editMode)
            state.editMode = !state.editable.item._id;
        else
            state.editMode = state.editable.item._id !== this.state?.editable.item._id ? false : state.editMode;
        return state;
    }
    // ######################## Logic ########################
    saveAction = async () => {
        const order = this.state.editable;
        if (!order)
            return;
        try {
            await order.save();
            // @ts-ignore - this is a protected prop, shouldn't be like this
            if (!order.validationResults)
                this.setState({ editMode: false });
        }
        catch (err) {
            this.logError(err);
        }
    };
    deleteAction = () => {
        const order = this.state.editable;
        if (!order)
            return;
        Dialog_Confirmation.show({
            header: 'Are you sure?',
            content: this.renderDeleteDialog,
            buttons: [
                {
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => {
                        try {
                            await order.delete();
                            this.props.deselectItem?.();
                        }
                        catch (err) {
                            this.logError(err);
                            ModuleFE_Toaster.toastError(`Order ${order.item.name} has other entities depending on it`);
                        }
                    }
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: () => {
                    }
                }
            ]
        });
    };
    // ######################## Render ########################
    renderDeleteDialog = () => {
        const order = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete the order" }), _jsx("div", { children: order.item.name })] });
    };
    render() {
        return _jsx(Component_SwitchView, { mode: editKey, modes: [
                {
                    key: editKey,
                    renderer: () => _jsxs(LL_V_L, { className: 'quai-item-manager', id: 'editor-wrapper__order', children: [this.renderHeader(), _jsx(OrderItem_EditorRenderer, { editable: this.state.editable, editMode: this.state.editMode })] })
                }
            ] });
    }
    // ######################## Render - Header ########################
    renderHeader = () => {
        if (!this.state.editMode)
            return this.renderViewHeader();
        return this.renderEditHeader();
    };
    renderViewHeader = () => {
        const action = this.state.editable.item;
        let subtitle = capitalizeFirstLetter(action.type ?? '');
        if (action.subType)
            subtitle += ` | ${actionSubTypeLabelMap[action.subType]}`;
        return _jsx(Header_WithOptionMenu, { title: action.name, subtitle: subtitle, className: 'underline', menuActions: [
                {
                    label: 'Edit Action',
                    action: () => this.setState({ editMode: true })
                },
                {
                    label: 'Delete Action',
                    action: this.deleteAction,
                    // permissionKey: PermissionKeyFE_ActionEdit
                },
            ] });
    };
    renderEditHeader = () => {
        const action = this.state.editable.item;
        const title = action._id ? `Edit ${action.name}` : 'Add New Action';
        return _jsxs(LL_H_C, { className: 'manager__header edit-mode', children: [_jsx(LL_H_C, { className: 'manager__header__main', children: _jsx(LL_V_L, { className: 'manager__header__title', children: _jsx("div", { className: 'manager__header__title__label', children: title }) }) }), this.renderHeaderTail()] });
    };
    renderHeaderTail = () => {
        if (!this.state.editMode)
            return;
        const editable = this.state.editable;
        if (!this.state.editable?.item._id)
            return _jsxs(LL_H_C, { className: 'manager__header__tail', children: [_jsx(Button, { variant: 'secondary', onClick: this.props.deselectItem, children: "Cancel" }), _jsx(Button, { variant: 'primary', className: 'preferred-action', onClick: this.saveAction, children: "Save" })] });
        return _jsxs(LL_H_C, { className: 'manager__header__tail', children: [_jsx(TS_EditableItemStatus, { editable: this.state.editable }), _jsx(Button, { disabled: !editable.item.variableId, variant: 'primary', className: 'preferred-action', onClick: () => this.setState({ editMode: false }), children: "Done" })] });
    };
}
//# sourceMappingURL=EditorWrapper_Order.js.map